import { StytchB2BUIClient } from '@stytch/vanilla-js/b2b';
import { StytchB2BHeadlessClient } from '@stytch/vanilla-js/b2b/headless';

import { getStytchCookieOptions } from '@/constants/auth';

let b2bHeadlessClient: StytchB2BHeadlessClient | null = null;
let b2bUiClient: StytchB2BUIClient | null = null;

const getB2BPublicToken = () => {
  const token = import.meta.env.VITE_STYTCH_B2B_PUBLIC_TOKEN;
  if (!token) {
    throw new Error(
      'VITE_STYTCH_B2B_PUBLIC_TOKEN is required for B2B authentication. ' +
        'The B2C token (VITE_STYTCH_PUBLIC_TOKEN) is not compatible with B2B SDK.',
    );
  }
  return token;
};

export const getStytchB2BHeadlessClient = () => {
  if (!b2bHeadlessClient) {
    b2bHeadlessClient = new StytchB2BHeadlessClient(getB2BPublicToken(), {
      cookieOptions: getStytchCookieOptions(),
    });
  }

  return b2bHeadlessClient;
};

export const getStytchB2BUIClient = () => {
  if (!b2bUiClient) {
    b2bUiClient = new StytchB2BUIClient(getB2BPublicToken(), {
      cookieOptions: getStytchCookieOptions(),
    });
  }

  return b2bUiClient;
};
